import { Box, Tooltip } from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import { useCurrentColors } from '../../hooks/UseCurrentColors/UseCurrentColors';
export default function CanopyTooltip({
    children,
    label,
    noOfLines,
    ...props
}: any) {
    const ref = useRef(null);
    const [isOverflown, setIsOverflown] = useState(false);
    const [reRender, setReRender] = useState({});
    const currentColors = useCurrentColors();
    const element: any = ref.current!;
    useEffect(() => {
        if (element?.clientWidth === undefined) {
            setReRender({});
            return;
        }
        setIsOverflown(
            element?.scrollWidth * (noOfLines || 1) > element?.clientWidth
        );
    }, [element?.clientWidth]);
    if (noOfLines) {
        return (
            <Tooltip
                label={label}
                aria-label={label}
                hasArrow
                placement="bottom-start"
                isDisabled={!isOverflown}>
                <Box
                    aria-label={label}
                    position="relative"
                    ref={ref}
                    noOfLines={noOfLines}
                    textOverflow="ellipsis"
                    whiteSpace="nowrap"
                    overflow="hidden"
                    {...props}>
                    {children}
                </Box>
            </Tooltip>
        );
    } else {
        return (
            <Tooltip
                label={label}
                aria-label={label}
                hasArrow
                placement="bottom-start"
                isDisabled={!isOverflown}>
                <Box
                    aria-label={label}
                    position="relative"
                    ref={ref}
                    textOverflow="ellipsis"
                    whiteSpace="nowrap"
                    overflow="hidden"
                    {...props}>
                    {children}
                </Box>
            </Tooltip>
        );
    }
}
